export default __webpack_public_path__ + "static/media/vw-june-spotlight.e440d2e6.webp";